import { render, staticRenderFns } from "./PermEditDialog.vue?vue&type=template&id=31f83c83&"
import script from "./PermEditDialog.vue?vue&type=script&lang=ts&"
export * from "./PermEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports